import * as React from 'react';
import { Button } from '@mui/material';
import { useFilterList } from '../../../context/FilterListProvider';

/** Props for {@link NewRuleButton}. */
export interface INewRuleButtonProps {
    /** Invoked with the currently applied filter list when the button is clicked. */
    callback: (filterList: Record<string, any>) => void;
}

/**
 * Toolbar button that opens the "New Rule" dialog, seeding it with the
 * currently applied filter list (source/tags/name).
 * @param props - `callback`, invoked with the current filter list when clicked.
 */
export const NewRuleButton: React.FC<INewRuleButtonProps> = ({ callback }) => {
    const [filterList] = useFilterList();
    const onNewRule = () => callback(filterList);
    return (
        <Button size="small" onClick={onNewRule} >New Rule</Button>
    );
};

export default NewRuleButton;
